{
  "page": {
    "title": "Horarios",
    "subtitle": "Define los turnos de tu empresa y arma el cuadro de turnos de cada sede.",
    "noAccess": "No tienes acceso a los horarios."
  },
  "tabs": {
    "label": "Secciones de horarios",
    "cuadro": "Cuadro de turnos",
    "turnos": "Turnos",
    "patrones": "Patrones",
    "feriados": "Feriados",
    "ausencias": "Ausencias"
  },
  "weekday": {
    "short": {
      "1": "lu",
      "2": "ma",
      "3": "mi",
      "4": "ju",
      "5": "vi",
      "6": "sá",
      "7": "do"
    },
    "long": {
      "1": "Lunes",
      "2": "Martes",
      "3": "Miércoles",
      "4": "Jueves",
      "5": "Viernes",
      "6": "Sábado",
      "7": "Domingo"
    }
  },
  "format": {
    "hours": "{hours} h",
    "hoursMinutes": "{hours} h {minutes} min",
    "minutes": "{minutes} min",
    "and": " y "
  },
  "source": {
    "MANUAL": "Manual",
    "INTEGRATION": "Integración"
  },
  "origin": {
    "GRID": "Ajuste manual",
    "PATTERN": "Patrón",
    "INTEGRATION": "Integración"
  },
  "absenceType": {
    "PERMISSION": "Permiso",
    "VACATION": "Vacaciones",
    "LICENSE": "Licencia",
    "MEDICAL_LEAVE": "Descanso médico"
  },
  "grid": {
    "label": "Cuadro de turnos",
    "description": "Selecciona días con clic, Shift+clic o arrastrando y asígnales un turno, descanso o sin horario.",
    "timezoneHint": "Días y horas en la zona de la sede: {timezone}.",
    "keyboardHint": "Con el teclado: flechas para moverte, Espacio para seleccionar, Shift+Espacio para seleccionar un rango, Enter o clic derecho para ver el historial del día y Escape para limpiar la selección.",
    "readOnlyHint": "Solo lectura. Enter o clic derecho sobre un día muestra su historial.",
    "worker": "Trabajador",
    "activePattern": "Patrón: {name}",
    "holidayHeader": "feriado: {name}",
    "filters": {
      "legend": "Filtros del cuadro de turnos",
      "site": "Sede",
      "fromDay": "Desde",
      "toDay": "Hasta",
      "worker": "Trabajador",
      "allWorkers": "Todos los trabajadores",
      "workerSearch": "Busca por nombre o código",
      "search": "Buscar por nombre",
      "rangeRequired": "Elige las fechas desde y hasta.",
      "rangeInverted": "La fecha final no puede ser anterior a la inicial.",
      "rangeTooLong": "El cuadro puede mostrar como máximo {max} días."
    },
    "cell": {
      "restCode": "D",
      "rest": "Descanso",
      "off": "Sin horario",
      "manual": "ajuste manual",
      "pattern": "según patrón",
      "integration": "desde integración",
      "holiday": "feriado: {name}",
      "absencePartial": "{type} por horas",
      "error": "no se guardó: {message}"
    },
    "lock": {
      "PERIOD_CLOSED": "bloqueado: período cerrado",
      "INTEGRATION": "bloqueado: viene de un sistema integrado",
      "OUTSIDE_EMPLOYMENT": "bloqueado: fuera de la relación laboral"
    },
    "actions": {
      "label": "Acciones sobre los días seleccionados",
      "count": "{count} días seleccionados",
      "modeLabel": "Qué asignar",
      "assign": "Asignar turno",
      "rest": "Descanso",
      "off": "Sin horario",
      "firstShift": "Turno",
      "secondShift": "Segundo turno (opcional)",
      "choose": "Elige un turno",
      "noSecond": "Sin segundo turno",
      "search": "Busca por código o nombre",
      "noTemplates": "No hay turnos activos.",
      "save": "Guardar ({count})",
      "history": "Ver historial",
      "clear": "Limpiar selección",
      "tooMany": "Puedes guardar como máximo {max} días a la vez. Reduce la selección."
    },
    "errors": {
      "title": "{count} días no se guardaron",
      "nothingSaved": "No se guardó ningún cambio. Corrige estos días y vuelve a guardar.",
      "item": "{worker} · {day}: {message}"
    },
    "toast": {
      "saved": "Guardamos {saved} días",
      "savedWithUnchanged": "Guardamos {saved} días · {unchanged} sin cambios"
    },
    "empty": {
      "title": "Aún no hay turnos en esta sede",
      "description": "Crea turnos en la pestaña Turnos y asígnalos aquí.",
      "goToTemplates": "Ir a Turnos"
    },
    "noWorkers": {
      "title": "No hay trabajadores para mostrar",
      "description": "Prueba con otra sede o cambia los filtros."
    },
    "noSites": {
      "title": "No hay sedes activas",
      "description": "Necesitas al menos una sede activa para armar el cuadro de turnos."
    },
    "error": {
      "title": "No pudimos cargar el cuadro de turnos",
      "description": "Revisa tu conexión e inténtalo nuevamente."
    }
  },
  "history": {
    "title": "Historial del día",
    "description": "{worker} · {day}",
    "empty": "Este día nunca tuvo horario asignado.",
    "current": "Vigente",
    "superseded": "Reemplazada",
    "meta": "{when} · {who} · {origin}",
    "site": "Sede: {site}",
    "supersededAt": "Reemplazada el {when}",
    "system": "Sistema"
  },
  "templates": {
    "description": "Plantillas de turno con su horario vigente. Cambiar un horario crea una versión nueva.",
    "new": "Nuevo turno",
    "crossesMidnight": "Cruza la medianoche",
    "companyTolerance": "Tolerancia de la empresa ({minutes} min)",
    "companyToleranceUnknown": "Tolerancia de la empresa",
    "companyShort": "la de la empresa",
    "ownTolerance": "Tardanza {late} · Salida {early}",
    "inUse": "En uso",
    "notInUse": "Sin uso",
    "current": "(vigente)",
    "fromStart": "Desde el inicio",
    "versionLabel": "v{version}",
    "versionBreak": "Refrigerio {minutes} min",
    "versionCreated": "{when} · {who}",
    "viewLabel": "Ver turno {name}",
    "status": {
      "ACTIVE": "Activo",
      "ARCHIVED": "Archivado"
    },
    "filters": {
      "legend": "Filtros de turnos",
      "statusLabel": "Estado",
      "status": {
        "ACTIVE": "Activos",
        "ARCHIVED": "Archivados",
        "ALL": "Todos"
      }
    },
    "columns": {
      "code": "Código",
      "name": "Nombre",
      "schedule": "Horario",
      "duration": "Duración",
      "break": "Refrigerio",
      "tolerances": "Tolerancias",
      "source": "Origen",
      "status": "Estado",
      "detail": "Ver"
    },
    "versionColumns": {
      "version": "Versión",
      "from": "Vigente desde",
      "schedule": "Horario",
      "detail": "Detalle"
    },
    "fields": {
      "name": "Nombre",
      "code": "Código",
      "startTime": "Inicio",
      "endTime": "Fin",
      "breakMinutes": "Refrigerio (min)",
      "ownTolerances": "Usar tolerancias propias",
      "lateTolerance": "Tolerancia de tardanza (min)",
      "earlyLeaveTolerance": "Tolerancia de salida anticipada (min)",
      "effectiveFrom": "Vigente desde"
    },
    "form": {
      "createTitle": "Nuevo turno",
      "createDescription": "Las horas son locales de la sede donde se asigne el turno.",
      "renameTitle": "Editar nombre",
      "renameDescription": "Cambiar el nombre o el código no cambia el horario.",
      "submit": "Crear turno",
      "help": {
        "code": "De 1 a 4 letras o números.",
        "endTime": "Si termina antes de empezar, cruza la medianoche",
        "duration": "Dura {duration}",
        "breakMinutes": "No se marca: se descuenta de las horas trabajadas.",
        "companyTolerances": "Se usan las tolerancias de la empresa: tardanza {late} min, salida anticipada {early} min.",
        "companyTolerancesUnknown": "Se usan las tolerancias de la empresa."
      },
      "errors": {
        "name": "Escribe un nombre de 1 a 60 caracteres.",
        "code": "Usa de 1 a 4 letras o números.",
        "start_time": "Elige la hora de inicio.",
        "end_time": "Elige la hora de fin.",
        "break_minutes": "El refrigerio debe estar entre 0 y 180 minutos.",
        "late_tolerance_minutes": "La tolerancia debe estar entre 0 y 60 minutos.",
        "early_leave_tolerance_minutes": "La tolerancia debe estar entre 0 y 60 minutos.",
        "effective_from": "Elige desde qué día rige el nuevo horario.",
        "nameTaken": "Ya existe un turno activo con ese nombre.",
        "codeTaken": "Ya existe un turno activo con ese código."
      }
    },
    "version": {
      "title": "Cambiar horario de {name}",
      "description": "Se crea una versión nueva del turno con la fecha desde la que rige.",
      "notice": "Los días anteriores se siguen evaluando con el horario anterior.",
      "submit": "Guardar nuevo horario"
    },
    "drawer": {
      "title": "Turno",
      "description": "Horario vigente y todas sus versiones.",
      "versions": "Versiones",
      "changeTimes": "Cambiar horario",
      "rename": "Editar nombre",
      "archive": "Archivar",
      "archivedAt": "Archivado el {when} por {who}."
    },
    "archive": {
      "title": "¿Archivar {name}?",
      "description": "Dejará de ofrecerse para asignar. Las asignaciones existentes no cambian y el turno no se borra.",
      "inUse": "Este turno está en uso: los días ya asignados lo conservan.",
      "confirm": "Archivar"
    },
    "toast": {
      "created": "Creamos el turno {name}",
      "renamed": "Guardamos los cambios del turno",
      "versioned": "Guardamos la versión {version} del horario",
      "archived": "Archivamos el turno {name}"
    },
    "empty": {
      "title": "Aún no hay turnos",
      "description": "Crea el primero, por ejemplo \"Mañana\" de 08:00 a 17:00."
    },
    "noResults": {
      "title": "No hay turnos con ese estado",
      "description": "Cambia el filtro de estado para ver otros turnos."
    },
    "error": {
      "title": "No pudimos cargar los turnos",
      "description": "Revisa tu conexión e inténtalo nuevamente."
    }
  },
  "patterns": {
    "description": "Patrones de turnos que se repiten (semanal, 4×4, 6×1…). Al aplicarlos, Fermin genera los días en el cuadro.",
    "new": "Nuevo patrón",
    "kind": {
      "WEEKLY": "Semanal",
      "CYCLE": "Ciclo de {n} días"
    },
    "status": {
      "ACTIVE": "Activo",
      "ARCHIVED": "Archivado"
    },
    "filters": {
      "legend": "Filtros de patrones",
      "statusLabel": "Estado",
      "status": {
        "ACTIVE": "Activos",
        "ARCHIVED": "Archivados",
        "ALL": "Todos"
      }
    },
    "columns": {
      "name": "Nombre",
      "kind": "Tipo",
      "cycle": "Ciclo",
      "source": "Origen",
      "status": "Estado",
      "actions": "Acciones"
    },
    "actions": {
      "apply": "Aplicar a trabajadores",
      "applyLabel": "Aplicar el patrón {name} a trabajadores",
      "edit": "Editar",
      "editLabel": "Editar el patrón {name}",
      "archive": "Archivar",
      "archiveLabel": "Archivar el patrón {name}"
    },
    "archive": {
      "title": "¿Archivar {name}?",
      "description": "Dejará de ofrecerse para aplicar. El patrón no se borra.",
      "notice": "Las aplicaciones activas siguen generando días hasta su fin; puedes terminarlas en la lista de aplicaciones.",
      "confirm": "Archivar patrón"
    },
    "editor": {
      "createTitle": "Nuevo patrón",
      "editTitle": "Editar {name}",
      "description": "Define qué turno toca cada día del ciclo. Las horas son locales de la sede donde se aplique.",
      "name": "Nombre",
      "kind": "Tipo",
      "kindCycle": "Ciclo de N días",
      "cycleDays": "Días del ciclo (N)",
      "weeklyHelp": "Alineado a la semana: el día 1 es el lunes.",
      "cycleHelp": "Se repite cada N días desde la fecha en que se aplica (por ejemplo, 4×4 = 8 días).",
      "kindLocked": "El tipo y la duración del ciclo no se cambian. Crea otro patrón si necesitas otro ciclo.",
      "days": "Días del ciclo ({count})",
      "dayN": "Día {n}",
      "firstLabel": "{day}: turno o descanso",
      "secondLabel": "{day}: segundo turno",
      "rest": "Descanso",
      "noSecond": "Sin segundo turno",
      "submit": "Crear patrón",
      "errors": {
        "name": "Escribe un nombre de 1 a 60 caracteres.",
        "nameTaken": "Ya existe un patrón activo con ese nombre.",
        "cycleDays": "El ciclo debe tener entre {min} y {max} días."
      }
    },
    "preview": {
      "title": "Vista previa de 14 días",
      "label": "Vista previa de {count} días",
      "weeklyHint": "Así quedarían los próximos 14 días si se aplicara desde hoy.",
      "cycleHint": "Así quedarían los próximos 14 días si se aplicara desde hoy, empezando en el día 1 del ciclo.",
      "cellLabel": "{weekday} {day} (día {index} del ciclo): {content}",
      "undefined": "sin definir"
    },
    "apply": {
      "title": "Aplicar {name}",
      "description": "Fermin genera los turnos de cada trabajador día por día. Los días de un período cerrado no se tocan.",
      "workers": "Trabajadores",
      "workersHelp": "{count} de {max} como máximo.",
      "addWorker": "Agrega un trabajador",
      "removeWorker": "Quitar a {name}",
      "startAt": "Empieza en el día N del ciclo (1–{max})",
      "site": "Sede",
      "primarySite": "Sede principal de cada trabajador",
      "startDay": "Desde",
      "endDay": "Hasta (opcional)",
      "replaceManual": "Reemplazar también los ajustes manuales",
      "review": "Revisar",
      "submit": "Aplicar",
      "summaryEmpty": "Revisa el resumen antes de aplicar.",
      "summaryStale": "Cambiaste los datos: vuelve a revisar el resumen antes de aplicar.",
      "summaryKeep": "Se generarán {generated} días · {manual} ajustes manuales se conservan · {closed} días cerrados",
      "summaryReplace": "Se generarán {generated} días · {manual} ajustes manuales se reemplazarán · {closed} días cerrados",
      "generatedUntil": "Días generados hasta el {day}.",
      "confirmText": "Vas a reemplazar {count} ajustes manuales hechos en el cuadro por los turnos del patrón. Pulsa de nuevo para confirmar.",
      "confirmReplace": "Reemplazar {count} ajustes y aplicar",
      "errors": {
        "workers": "Agrega al menos un trabajador.",
        "startAt": "Elige un día entre 1 y {max}.",
        "start_day": "Elige desde qué día se aplica.",
        "end_day": "Revisa la fecha final.",
        "site_id": "Elige una sede válida.",
        "pattern_id": "Elige un patrón válido."
      }
    },
    "applications": {
      "title": "Aplicaciones",
      "description": "Trabajadores con un patrón asignado y hasta dónde está generado su horario.",
      "filters": {
        "legend": "Filtros de aplicaciones",
        "pattern": "Patrón",
        "allPatterns": "Todos los patrones",
        "worker": "Trabajador",
        "allWorkers": "Todos los trabajadores",
        "statusLabel": "Estado",
        "status": {
          "ACTIVE": "Activas",
          "ENDED": "Terminadas",
          "ALL": "Todas"
        }
      },
      "columns": {
        "worker": "Trabajador",
        "pattern": "Patrón",
        "site": "Sede",
        "period": "Período",
        "offset": "Empieza en",
        "generatedUntil": "Generado hasta",
        "status": "Estado",
        "actions": "Acciones"
      },
      "period": "{from} al {to}",
      "openPeriod": "Desde el {from}, sin fecha de fin",
      "offset": "Día {n} del ciclo",
      "notGenerated": "Sin generar",
      "status": {
        "ACTIVE": "Activa",
        "ENDED": "Terminada"
      },
      "endReason": {
        "REPLACED": "Reemplazada por otro patrón",
        "ADMIN": "Terminada por un administrador",
        "WORKER_DEACTIVATED": "Trabajador desactivado"
      },
      "end": "Terminar",
      "endLabel": "Terminar el patrón {pattern} de {worker}",
      "empty": "Aún no hay patrones aplicados",
      "noResults": "No hay aplicaciones con esos filtros",
      "error": "No pudimos cargar las aplicaciones"
    },
    "end": {
      "title": "Terminar aplicación",
      "description": "{pattern} · {worker} · desde el {start}",
      "notice": "Los días posteriores que ya estaban generados quedan sin horario. Los ajustes manuales se conservan.",
      "endDay": "Último día con el patrón",
      "confirm": "Terminar aplicación",
      "errors": {
        "endDay": "Elige el último día.",
        "beforeStart": "El último día no puede ser anterior al inicio ({day})."
      }
    },
    "toast": {
      "created": "Creamos el patrón {name}",
      "updated": "Guardamos los cambios del patrón {name}",
      "archived": "Archivamos el patrón {name}",
      "applied": "Aplicamos {name} a {workers} trabajadores · {days} días generados",
      "ended": "Terminamos {pattern} para {worker}"
    },
    "empty": {
      "title": "Aún no hay patrones",
      "description": "Crea uno, por ejemplo \"Semana oficina\" de lunes a viernes, y aplícalo a varios trabajadores."
    },
    "noResults": {
      "title": "No hay patrones con ese estado",
      "description": "Cambia el filtro de estado para ver otros patrones."
    },
    "error": {
      "title": "No pudimos cargar los patrones"
    },
    "errors": {
      "archived": "Este patrón está archivado: ya no se puede aplicar ni editar.",
      "ended": "Esta aplicación ya terminó."
    }
  },
  "holidays": {
    "description": "Un feriado no cuenta como falta: ese día se evalúa como Feriado. Puede ser de toda la empresa o de una sede.",
    "new": "Nuevo feriado",
    "caption": "Feriados de {year}",
    "scope": {
      "company": "Todas las sedes"
    },
    "status": {
      "ACTIVE": "Vigente",
      "REMOVED": "Retirado"
    },
    "filters": {
      "legend": "Filtros de feriados",
      "year": "Año",
      "site": "Sede",
      "allSites": "Todas",
      "includeRemoved": "Mostrar retirados"
    },
    "columns": {
      "day": "Fecha",
      "name": "Nombre",
      "scope": "Alcance",
      "source": "Origen",
      "status": "Estado",
      "actions": "Acciones"
    },
    "remove": "Retirar",
    "removeLabel": "Retirar el feriado {name}",
    "form": {
      "title": "Nuevo feriado",
      "description": "Se aplica al día de cada sede, en su zona horaria.",
      "day": "Fecha",
      "name": "Nombre",
      "scope": "Alcance",
      "scopeHelp": "Un feriado de sede solo afecta a los días de esa sede.",
      "submit": "Registrar feriado",
      "errors": {
        "day": "Elige la fecha.",
        "name": "Escribe un nombre de 1 a 80 caracteres.",
        "site_id": "Elige un alcance válido.",
        "dayTaken": "Ya hay un feriado ese día para ese alcance."
      }
    },
    "removeDialog": {
      "title": "¿Retirar el feriado {name}?",
      "description": "{day} · {scope}",
      "notice": "Esos días vuelven a evaluarse con normalidad. El feriado no se borra: queda en el historial como retirado.",
      "confirm": "Retirar feriado"
    },
    "toast": {
      "created": "Registramos el feriado {name} ({day})",
      "removed": "Retiramos el feriado {name}"
    },
    "empty": {
      "title": "No hay feriados en {year}",
      "description": "Registra los feriados nacionales y los locales de cada sede."
    },
    "noResults": {
      "title": "No hay feriados con esos filtros",
      "description": "Prueba con otro año o sede."
    },
    "error": {
      "title": "No pudimos cargar los feriados"
    }
  },
  "errors": {
    "SCHEDULE_CHANGED": "Este día cambió mientras lo editabas. Revisa el valor actual."
  },
  "managed": {
    "cellNotice": "Este día viene del sistema integrado: se cambia allí y se actualiza al sincronizar.",
    "templateNotice": "Se cambia en el sistema integrado y se actualiza al sincronizar.",
    "holidayLocked": "{system}: no se puede retirar aquí."
  }
}
